import { PDF_CONFIG } from "./config/pdfConfig";
import { pdfAPI } from "../api";

const splitDate = (dateValue, prefix) => {
  if (!dateValue) return null;

  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return null;

    const jour = date.getDate().toString().padStart(2, "0");
    const mois = (date.getMonth() + 1).toString().padStart(2, "0");
    const annee = date.getFullYear().toString();

    return {
      [`${prefix}_J1`]: jour[0],
      [`${prefix}_J2`]: jour[1],
      [`${prefix}_M1`]: mois[0],
      [`${prefix}_M2`]: mois[1],
      [`${prefix}_A1`]: annee[0],
      [`${prefix}_A2`]: annee[1],
      [`${prefix}_A3`]: annee[2],
      [`${prefix}_A4`]: annee[3],
    };
  } catch (error) {
    console.error(`Erreur date ${prefix}:`, error);
    return null;
  }
};

export const transformFormData = (formData) => {
  console.log("=== DÉBUT TRANSFORMATION ===");
  console.log("FormData reçu:", formData);

  const transformed = { ...formData };

  // 2. Traitement des boutons radio en utilisant PDF_CONFIG
  if (PDF_CONFIG.radioGroups) {
    Object.entries(PDF_CONFIG.radioGroups).forEach(([groupName, config]) => {
      const selectedValue = formData[groupName];

      if (selectedValue && config.values && config.values[selectedValue]) {
        Object.assign(transformed, config.values[selectedValue]);
        delete transformed[groupName];
      }
    });
  }

  // 3. Traitement des dates
  if (PDF_CONFIG.dateFields) {
    Object.entries(PDF_CONFIG.dateFields).forEach(([fieldName, config]) => {
      if (formData[fieldName]) {
        const dateFields = splitDate(formData[fieldName], config.prefix);
        if (dateFields) {
          Object.assign(transformed, dateFields);
          delete transformed[fieldName];
        }
      }
    });
  }

  // 4. Traitement des checkboxes (conversion boolean -> Yes/Off)
  Object.entries(transformed).forEach(([key, value]) => {
    if (key.startsWith("VEH_32_")) {
      transformed[key] = value === true ? "Yes" : "Off";
    }
  });

  // 5. Nettoyer les champs inutiles
  const fieldsToRemove = [
    "dossierNum",
    "statut",
    "vendeur",
    "certificationType",
    "usage",
    "HAS_COC_ELECTRONIC",
    "nuance",
    "vehiculeType",
    "isTest",
    "CouleurDominante",
  ];

  fieldsToRemove.forEach((field) => {
    delete transformed[field];
  });

  console.log("Données transformées finales:", transformed);
  return transformed;
};

export const generatePDF = async (formData) => {
  try {
    console.log("=== Début de la génération PDF ===");
    const transformedData = transformFormData(formData);

    if (formData.isTest) {
      const testForms = [
        "Cerfa_13749-05.pdf",
        "Cerfa_13750-07.pdf",
        "Cerfa_13751-02.pdf",
        "Cerfa_15776-02.pdf",
      ];

      const results = [];

      for (const formType of testForms) {
        try {
          const data = await pdfAPI.generatePDF(formType, transformedData);
          results.push({ type: formType, data });
        } catch (error) {
          console.error(`Erreur pour ${formType}:`, error);
          results.push({ type: formType, error: error.message });
        }
      }

      return results;
    } else {
      return await pdfAPI.generatePDF(formData.selectedForm, transformedData);
    }
  } catch (error) {
    console.error("Erreur lors de la génération du PDF:", error);
    throw error;
  }
};

export const getPdfFieldsDetails = async (pdfType) => {
  try {
    console.log("Demande des champs pour:", pdfType);
    const data = await pdfAPI.getFieldsDetails(pdfType);
    console.log("Réponse du serveur:", data);
    return data;
  } catch (error) {
    console.error("Erreur lors de la récupération des champs:", error);
    throw error;
  }
};
